import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title } from '../../components/Shared/TitleSuccess';
import { ActionTypes } from '../../utils/enums';

import { setExitingCardProps, getExitingCardProps } from '../Widget/actions';

const TitleComponent = props => <Title>{props.title}</Title>;

TitleComponent.propTypes = {
    title: PropTypes.string.isRequired
};

const ElectionReminderSuccess = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            fullWidth
            thankYouText={props.thankYouText}
            titleComponent={<TitleComponent title={props.title} />}
            hideSubtitle={true}
            beforeAdvancing={() => {
                props.setExitingCardProps('electionReminder', props, props.exitingAction);
            }}
            {...props}
        />
    </TransitionContainerNoExit>
);

ElectionReminderSuccess.propTypes = {
    exitingAction: PropTypes.object.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    thankYouText: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'electionReminder',
            ['/electionReminder/success'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        return {
            exitingAction: state.widget.activeAction,
            title: `You're now signed up to receive reminders for upcoming elections.`,
            thankYouText: `You'll be getting emails in advance of major electoral events such as your state primaries and general elections. Make your voice heard.`
        };
    },
    { setExitingCardProps },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.ElectionReminder)
                return true;

            return next === prev;
        }
    }
)(ElectionReminderSuccess);
